const notiSoundKey = "isEnableNotiSound"

export default {
  namespaced: true,
  state: {
    isEnableNotiSound: JSON.parse(localStorage.getItem(notiSoundKey)) ?? true,
  },

  mutations: {
    SET_NOTIFICATION_SOUND_ENABLED(state, value) {
      state.isEnableNotiSound = value
      localStorage.setItem(notiSoundKey, JSON.stringify(value))
    },
  },

  actions: {
    setNotificationSoundEnabled({ commit }, value) {
      commit("SET_NOTIFICATION_SOUND_ENABLED", value)
    },
  },

  getters: {
    getNotificationSoundEnabled: (state) => {
      return state.isEnableNotiSound
    },
  },
}
